import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import BodyHistory from './BodyHistory';
import HeaderHistory from './HeaderHistory';

function CardHistory() {
  const { isEmptyHistory, loading } = useMemberExtract();

  if (loading && isEmptyHistory) {
    return null;
  }

  return (
    <>
      <div className={`corporate-club-extract__card ${isEmptyHistory ? 'corporate-club-extract__card--empty' : ''}`}>
        <HeaderHistory />
        <BodyHistory />
      </div>
    </>

  );
}

export default CardHistory;
